module.exports = __webpack_public_path__ + "static/media/bg-sign.da1a0e06.png";